import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to an element with the given hash after a short delay so that
 * navigating from /privacy → /#features works smoothly.
 */
export default function ScrollToHash() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (!hash) {
            window.scrollTo({ top: 0, left: 0, behavior: "instant" });
            return;
        }
        const id = hash.replace(/^#/, "");
        const tryScroll = (attemptsLeft) => {
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
                return;
            }
            if (attemptsLeft > 0) {
                setTimeout(() => tryScroll(attemptsLeft - 1), 60);
            }
        };
        tryScroll(10);
    }, [pathname, hash]);

    return null;
}
